module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "prazo-do-dossie",
    class: 'prazo-do-dossie_' + _vm.situacao.estado
  }, [_c('div', {
    staticClass: "prazo-do-dossie__cabecalho"
  }, [_c('span', {
    staticClass: "prazo-do-dossie__titulo"
  }, [_c('i', {
    staticClass: "far fa-clock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      Prazo do dossiê\n      "), (_vm.situacao.prorrogado) ? _c('span', {
    staticClass: "tags tags_cor-azul"
  }, [_vm._v("\n        Prorrogado\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.situacao.rotuloBotaoProrrogar) ? _c('button', {
    staticClass: "botao botao_medio botao_contorno botao_com-icone-para-esquerda prazo-do-dossie__botao-prorrogar",
    class: 'prazo-do-dossie__botao-prorrogar_' + _vm.situacao.estado,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('prorrogar')
      }
    }
  }, [_c('i', {
    staticClass: "far fa-clock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      " + _vm._s(_vm.situacao.rotuloBotaoProrrogar) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "prazo-do-dossie__status"
  }, [_c('span', {
    staticClass: "prazo-do-dossie__contagem"
  }, [_vm._v("\n      " + _vm._s(_vm.situacao.vencido ?
    _vm.situacao.diasEmAtraso +
    (_vm.situacao.diasEmAtraso === 1 ?
      " dia em atraso" :
      " dias em atraso") :
    _vm.situacao.diasRestantes +
    (_vm.situacao.diasRestantes === 1 ?
      " dia restante" :
      " dias restantes")) + "\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "prazo-do-dossie__detalhe"
  }, [_vm._v("\n      Dia " + _vm._s(_vm.situacao.diaAtual) + " de " + _vm._s(_vm.situacao.totalDeDias) + " ·\n      " + _vm._s(_vm.situacao.vencido ? "venceu em" : "vence em") + "\n      " + _vm._s(_vm.$tempo.formatarParaPadraoBrasileiro(_vm.situacao.dataDeVencimento)) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "prazo-do-dossie__barra"
  }, [_c('div', {
    staticClass: "prazo-do-dossie__barra-preenchida",
    style: ({
      width: _vm.situacao.percentualConsumido + '%'
    })
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-53cd2702", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53cd2702"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/components/PrazoDoDossie.vue
// module id = 1117
// module chunks = 1